
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M9.7 6.5V9H8v3h1.7v9h3.6v-9h2.4l.3-3h-2.7V6.9c0-.3.4-.7.8-.7H16V3h-2.6C9.6 3 9.7 6 9.7 6.5z"}})])
          )
        }
      }
    